import Rest from '../services/rest'
import {store} from '../store/store'

/**
 * @typedef {OrdersService}
 */
export default class OrdersService{

    constructor() {
        this.resource = "/orders"

        this.http = Rest.build(store.getters.token, this.resource);
    }

    static build() {
        return new this();
    }

    get_all(item){
        var parameters = new URLSearchParams(item);
       
        parameters = parameters.toString();
        if(parameters){
            parameters = "?"+parameters;
        }
        return this.http.get(`/all${parameters}`);
    }

    get_one(product_id){
        return this.http.get(`/${product_id}`)    
    }


}